import React from 'react';
import { useSelector } from 'react-redux';
import TreeView from '@mui/lab/TreeView';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { StyledTreeItem } from '../../../../../common/StyledTreeItem';
import Box from '@mui/material/Box';
import { AppState } from '../../../../../store';
declare module 'react' {
		interface CSSProperties {
				'--tree-view-color'?: string;
				'--tree-view-bg-color'?: string;
		}
}
export interface CategoriesListItem {
	_id: string;
	name: string;
	createAt: string;
	updatedAt: string;
	subcategories?: Array<any>;
}

export default function ProductCategories(props: any) {
	const [expanded, setExpanded] = React.useState<string[]>([]);
  	const [selected, setSelected] = React.useState<string[]>([]);

    const {categories, subcategories} = useSelector<AppState, AppState['categories']>(
        ({categories}) => categories,
    );

	const handleToggle = (event: React.SyntheticEvent, nodeIds: string[]) => {
		setExpanded(nodeIds);
	};
	
	const handleSelect = (event: React.SyntheticEvent, nodeIds: string[]) => {
		setSelected(nodeIds);
	};
	
	const getFormattedCategoryList = () => {
		let categoryListData = null
		if((categories && categories.length > 0) && (subcategories && subcategories.length > 0)) {
			categoryListData = categories.map((category: any) => {
				category.subcategories = subcategories.filter((subc: any) => category._id === subc.category_id)
				return category
			})
		}
		return categoryListData || []
	}

	const categoryListData: Array<any> = getFormattedCategoryList()
	
	return (
		<><Box component="h6" sx={{margin:'12px'}}>{props.title}</Box>
		<TreeView
				aria-label="Shopping Categories"
				defaultExpanded={expanded}
				defaultCollapseIcon={<ArrowDropDownIcon />}
				defaultExpandIcon={<ArrowRightIcon />}
				defaultEndIcon={<div style={{ width: 24 }} />}
				expanded={expanded}
				selected={selected}
				onNodeToggle={handleToggle}
				onNodeSelect={handleSelect}
				sx={{ maxHeight: '90%', flexGrow: 1, minWidth: 260, maxWidth: 450, overflowY: 'auto' }}
		>
			{categoryListData && categoryListData.length > 0
				&& categoryListData.map((categoryItem: CategoriesListItem) => {
				const subcategories: Array<any> = categoryItem.subcategories || [];
				return (
					<StyledTreeItem
						key={categoryItem._id}
						nodeId={categoryItem.name} 
						labelText={categoryItem.name}
					>
						{subcategories.length === 0 && 
							<StyledTreeItem
								nodeId={'not_found'}
								labelText={'Not Found'}
							/>
						}
						{subcategories.length > 0 && subcategories.map((subCategory: any) => {
							return <StyledTreeItem
								key={subCategory._id}
								nodeId={subCategory.name}
								labelText={subCategory.name}
								onClick={props.toggleDrawer(false, { selectedCategory: expanded[0], subCategory: subCategory.name })}
							/>
						})}
					</StyledTreeItem>
				)
			})}
		</TreeView>
		</>
	);
}
